import React, { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext({ theme: "light", toggleTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  // Le mode sombre a été retiré : l'application est toujours en thème clair
  // (sauf la navigation "Sombre futuriste" qui a son propre habillage dédié).
  const theme = "light";

  useEffect(() => {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("ophta-theme", "light");
  }, []);

  const toggleTheme = () => {};

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
